export default __webpack_public_path__ + "static/metamask-hero-0605f02daba7d3771098bcdf714e7ee4.svg";